import { render, staticRenderFns } from "./showcase.component.html?vue&type=template&id=4159005c&scoped=true&"
import script from "./Showcase.vue?vue&type=script&lang=ts&"
export * from "./Showcase.vue?vue&type=script&lang=ts&"
import style0 from "./showcase.component.scss?vue&type=style&index=0&id=4159005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159005c",
  null
  
)

export default component.exports